import OfferIcon from '@mui/icons-material/AttachMoney';

export default OfferIcon;
